import React from 'react';
import { connect } from 'react-redux';
import { Icon, Container, Menu } from 'semantic-ui-react';
import Txt from '../../../inputs/textInput.js';
import { ContextualMenu, hideWhenClickAwayOrResize, showHideMenu } from '../../../shared/contextualMenu/content';
import {
  clickedJoinRoom,
  updateWaitingAreaSearch,
  updateSelectedParticipantInWAForm,
  addToCallWaitingAreaParticipant,
  updateSelectedVideoCallRoom,
  updateSelectedVideoCallRoomId,
  getWaitingAreaCallHistory,
  createVidyoRoomAuthTicket,
  updateSelectedConsultNowCaller,
  updateInitiatedCNWaitingAreaSearch,
  updateInprogressCNWaitingAreaSearch,
} from '../../../../actions/waitingArea';
import { clearAllValidationErrors } from '../../../../businessLogic/validation.js';
import { sortWaitingAreaRooms } from '../../../../businessLogic/sorter.js';
import {
  updateShowWaitingAreaParticipant,
  updateShowNotifyRoomParticipant,
  showShowCallHistoryModal,
  showConfirmationCallMessModal,
} from '../../../../actions/modal';
import { getRemainingSecond } from '../../../../businessLogic/datetime';
import { getMinuteDiff, getDOBFormat } from '../../../helpers/date';
import RemainingTimeCountDown from './remainingTimeCountdown';
import ConsultNowContextMenu from './ConsultNowContextMenu.js';
import CenterPanelShared from './centerPanelShared';
import { Media } from '../../../../mediaSetting';

@connect(mapStateToProps)
export default class ViewOneWaitingAreaCenterPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // TODO : Why do we need local state
      id: props.id,
      waitingAreaRoomsFiltered: props.waitingAreaRoomsFiltered.slice().sort(sortWaitingAreaRooms),
      waitingAreaRoomSelected: {},
      currentRoomSelected: null,
      maxWidthAllowedForParticipantRow: 100,
      showParticipants: false,
      waitingAreaRoomsGray: props.waitingAreaRoomsGray,
      participantInfo: {},
      fetchingAuthTicket: false,
      authTicketId: '',
      hideWhenClickAwayOrResizeHandler: hideWhenClickAwayOrResize.bind(this, '.new-waiting-area-view-one', () => {
        this.setState({ showParticipants: false });
      }),
    };
  }

  updateWaitingAreaSearch = (e) => {
    if (e.target != undefined) this.props.dispatch(updateWaitingAreaSearch(e.target.value));
    else this.props.dispatch(updateWaitingAreaSearch(e));
  };

  updateInitiatedCNWaitingAreaSearch = (e) => {
    if (e.target != undefined) this.props.dispatch(updateInitiatedCNWaitingAreaSearch(e.target.value));
    else this.props.dispatch(updateInitiatedCNWaitingAreaSearch(e));
  };

  updateInprogressCNWaitingAreaSearch = (e) => {
    if (e.target != undefined) this.props.dispatch(updateInprogressCNWaitingAreaSearch(e.target.value));
    else this.props.dispatch(updateInprogressCNWaitingAreaSearch(e));
  };

  UNSAFE_componentWillReceiveProps = (props) => {
    this.setState({
      waitingAreaRoomsFiltered: props.waitingAreaRoomsFiltered.slice().sort(sortWaitingAreaRooms),
      waitingAreaRoomsGray: props.waitingAreaRoomsGray.slice().sort(sortWaitingAreaRooms),
      consultNowRoomsFiltered: props.consultNowRoomsFiltered.slice().sort(sortWaitingAreaRooms),
    });
  };

  componentDidMount = () => {
    window.$('body').click(this.state.hideWhenClickAwayOrResizeHandler);
    window.$(window).resize(this.state.hideWhenClickAwayOrResizeHandler);
  };

  UNSAFE_componentWillMount = () => {
    window.$('body').unbind('click', this.state.hideWhenClickAwayOrResizeHandler);
    window.$(window).unbind('resize', this.state.hideWhenClickAwayOrResizeHandler);
  };

  setCurrentActiveItem = (val) => {
    this._currentItem = val;
    return this._currentItem;
  };
  getCurrentActiveItem = () => {
    return this._currentItem;
  };

  mouseMovedOnTable = (e) => {
    let heightOfOneRow = 0;
    if (window.$(e.target).hasClass('right-column-fixed')) {
      heightOfOneRow = window.$(e.target).height();
    }
    this.mouseY = e.pageY - window.$(e.target).offset().top + heightOfOneRow;
  };

  joinRoom = (roomId) => {
    let waitingAreaRoomUserWantsToJoin = this.props.waitingArea.authTickets.find((x) => x.roomId == roomId); //search in ALL rooms, not only the ones filtered OR the ones in gray
    this.setState({ waitingAreaRoomSelected: waitingAreaRoomUserWantsToJoin });
    this.props.dispatch(clickedJoinRoom(roomId));
    let callscreenUrl =
      window.APP.CONFIGURATION.CALLSCREEN_LOCATION +
      '#/?authticket=' +
      waitingAreaRoomUserWantsToJoin.callScreenAuthTicket;

    callscreenUrl += '&video=' + (!!this.props.waitingArea.providerCallConfig.isCameraOn).toString().toLowerCase();
    callscreenUrl += '&audio=' + (!!this.props.waitingArea.providerCallConfig.isMicrophoneOn).toString().toLowerCase();

    window.open(
      callscreenUrl,
      null,
      'width=' + (screen.width - 20) + ',height=' + (screen.height - 100) + ', left=0, top=0, scrollbars=yes,status=yes'
    );

    var cbGetAuthTicket = (result, callScreenAuthTicket) => {
      if (!result) {
        console.error('No Auth Ticket was created');
        return;
      }
      this.setState({ authTicketId: callScreenAuthTicket });
    };
    this.props.dispatch(createVidyoRoomAuthTicket(this.props.waitingArea.id, roomId, cbGetAuthTicket));
    this.props.dispatch(showConfirmationCallMessModal(false));
    setTimeout(() => {
      $('.row.flexible.row-hoverable.active')
        .children('#' + roomId)
        .addClass('hidden');
    }, 200);
  };

  invite = (roomId) => {
    let waitingAreaRoomUserWantsToJoin = this.props.waitingArea.rooms.find((x) => x.id == roomId); //search in ALL rooms, not only the ones filtered OR the ones in gray
    this.setState({ waitingAreaRoomSelected: waitingAreaRoomUserWantsToJoin });

    this.showInviteModal();
  };

  showInviteModal = () => {
    window.$('.ui.modal.invite-guest-waiting-area').modal({ closable: false }).modal('show');
    window.$('.ui.modal.invite-guest-waiting-area .field input').change();
    clearAllValidationErrors();
  };

  viewHistory = (waitingAreaId, roomId) => {
    // Show the modal
    let cb = () => this.props.dispatch(showShowCallHistoryModal(true));
    this.props.dispatch(getWaitingAreaCallHistory(waitingAreaId, roomId, cb));
  };

  openParticipantModal = (particpant) => {
    this.setState({ selectedParticipant: particpant });

    this.props.dispatch(updateSelectedParticipantInWAForm(particpant));
    this.props.dispatch(updateShowWaitingAreaParticipant(true));
  };

  addToCall = (room) => {
    this.setState({ selectedRoom: room });
    this.props.dispatch(updateSelectedVideoCallRoom(room));
    let cb = () => {
      this.props.dispatch(showConfirmationCallMessModal(false));
      if (this.props.updateSelectedVideoCallRoom && typeof this.props.updateSelectedVideoCallRoom === 'function') {
        this.props.updateSelectedVideoCallRoom({});
      }
    };
    this.props.dispatch(addToCallWaitingAreaParticipant(room.mainParticipant, cb));
  };

  notifyRoomParticipant = (roomId, room) => {
    this.setState({ selectedRoom: room });
    this.props.dispatch(updateSelectedVideoCallRoom(room));
    this.props.dispatch(updateShowNotifyRoomParticipant(true));
  };

  anyCallNotInProgress = (rooms) => {
    // Return true when there are calls NOT "IN PROGRESS"
    return (
      rooms.length > 0 &&
      rooms.some((room, i) => room.mainParticipant.status != APP.LANGUAGE.ViewOneWaitingArea.Attended)
    );
  };

  getContextualMenu = (room, providerIsInCallWithSomeUser, answerCallPermission) => {
    let participants = '';
    if (room.participants.length > 0) {
      let finalOptions = room.participants.map((o, i) => {
        let personStatus = '';
        if (!o.isPrimaryCaller && o.participantStatus == 'A') {
          if (o.canAnswerCall) {
            personStatus = APP.LANGUAGE.WaitingAreaPersonStatus.Provider;
          } else {
            personStatus = APP.LANGUAGE.WaitingAreaPersonStatus.Guest;
          }
        } else if (!o.isPrimaryCaller && o.participantStatus == 'T') {
          personStatus = APP.LANGUAGE.WaitingAreaPersonStatus.Guest;
        }

        let textFinalParticipant = o.name + (personStatus != '' ? ` (${personStatus})` : '');
        return {
          style: {
            maxWidth: this.state.maxWidthAllowedForParticipantRow + '%',
          },
          text: textFinalParticipant + '...',
          onClick: () => {
            /*open o into a modal*/
            this.openParticipantModal(o);
          },
          id: o.id,
        };
      });
      participants = (
        <Txt
          key={room.id}
          multiple={true}
          semanticui
          dropdown
          onClick={() => {
            this.setState({
              showParticipants: !this.state.showParticipants,
            });
          }}
          open={this.state.showParticipants}
          text={APP.LANGUAGE.ViewOneWaitingArea.Participants}
          noIcon={true}
          className=" button labeled color-info max-width no-bold icon left-text normal participantsdropdown"
          options={finalOptions}
        />
      );
    } else {
      participants = (
        <div className="ui  max-width">
          <span className="text pdls">{APP.LANGUAGE.ViewOneWaitingArea.NoParticipantsMessage}</span>
        </div>
      );
    }

    let AddToCurrentCall = (
      <div>
        {APP.LANGUAGE.ViewOneWaitingArea.AddToCurrentCall} &nbsp;
        <i className="ui icon plus add waiting-area-green fr" />
      </div>
    );

    let otherProviderIsInCall = (room) => {
      if (room.participants.length > 1) {
        let otherProviders = room.participants.filter(
          (participant) => participant.canAnswerCall === true && participant.participantStatus === 'A'
        );
        return otherProviders.length > 0;
      }
      return false;
    };

    let joinTitle = this.state.fetchingAuthTicket ? (
      <div className="color-placeholder">
        {APP.LANGUAGE.ViewOneWaitingArea.JoinAction}
        <i className="ui icon spinner loading icon waiting-area-green fr" />
      </div>
    ) : (
      <div>
        {otherProviderIsInCall(room)
          ? APP.LANGUAGE.ViewOneWaitingArea.OtherProviderJoinAction
          : APP.LANGUAGE.ViewOneWaitingArea.JoinAction}
        <i className="ui icon sign in waiting-area-green fr" />
      </div>
    );
    let canProviderAddtoCall =
      !this.props.isConsultNowIssued &&
      !room.isCurrentUserAnsweringThisCall &&
      providerIsInCallWithSomeUser &&
      !this.props.isCurrentUserInGCCall &&
      room.participants.length == 1 &&
      answerCallPermission;

    return (
      <ContextualMenu
        id={room.id}
        options={[
          {
            title: joinTitle,
            customAction: true,
            show: !room.isCurrentUserAnsweringThisCall && answerCallPermission,
            action: () => {
              if (this.state.fetchingAuthTicket || providerIsInCallWithSomeUser || this.props.isCurrentUserInGCCall) {
                return;
              }
              return otherProviderIsInCall(room)
                ? this.props.dispatch(
                    showConfirmationCallMessModal(true, () => this.joinRoom(room.id), room.participants, 'join')
                  )
                : this.joinRoom(room.id);
            },
            fieldClass: this.state.fetchingAuthTicket || providerIsInCallWithSomeUser ? 'disable-msg' : '',
          },
          {
            title: <div> {APP.LANGUAGE.ViewOneWaitingArea.cannotJoinAction} </div>,
            customAction: false,
            show: !answerCallPermission,
            fieldClass: 'disable-msg',
          },
          {
            title: APP.LANGUAGE.ViewOneWaitingArea.CallerInConsultation,
            customAction: false,
            //if there are more than one participant
            show: room.isCurrentUserAnsweringThisCall && room.participants.length > 1 && answerCallPermission,
            fieldClass: 'disable-msg',
          },
          {
            title: <div> {APP.LANGUAGE.ViewOneWaitingArea.AddToCall} </div>,
            customAction: false,
            show: !canProviderAddtoCall,
            fieldClass: 'disable-msg',
          },
          {
            //either join or add, one of them will be visible
            title: AddToCurrentCall,
            customAction: true,
            //if current user is not answering the call, and provider is in call with other user
            //and only one participant in room
            show: canProviderAddtoCall,
            action: () => {
              this.props.dispatch(
                showConfirmationCallMessModal(true, () => this.addToCall(room), room.participants, 'add')
              );
            },
          },
          {
            //Notify Participants
            title: <div> {APP.LANGUAGE.ViewOneWaitingArea.Notify} </div>, //keep in div if you dont want to close the context menu
            customAction: true,
            action: () => this.notifyRoomParticipant(room.id, room),
          },
          {
            //View call activity
            title: <div> {APP.LANGUAGE.ViewOneWaitingArea.ViewHistoryAction} </div>, //keep in div if you dont want to close the context menu
            customAction: true,
            action: () => this.viewHistory(this.props.waitingArea.id, room.id),
          },
          {
            renderAsChild: true,
            childComponent: participants,
          },
        ]}
      />
    );
  };

  render() {
    const { waitingArea } = this.props;

    let newRoomInWaitingAreaSound = '';
    if (waitingArea.newRooms) {
      newRoomInWaitingAreaSound = <audio src={window.APP.AUDIO.NewRoomInWaitingAreas} autoPlay />;
    }

    let calculateIcon = (status) => {
      let iconToReturn = '';
      if (status == APP.LANGUAGE.ViewOneWaitingArea.Waiting)
        iconToReturn = <i className=" ui icon clock  show-on-small-ress mrrnull" />;
      else if (status == APP.LANGUAGE.ViewOneWaitingArea.Idle)
        iconToReturn = <i className=" ui icon  exclamation show-on-small-ress mrrnull" />;
      else if (status == APP.LANGUAGE.ViewOneWaitingArea.Attended)
        iconToReturn = <i className=" ui icon checkmark  show-on-small-ress mrrnull" />;
      return iconToReturn;
    };
    let contextualMenu = '';
    let peopleRows = '';
    let peopleGray = '';

    let renderWaitingArea = (gray) => {
      let iterator = gray ? this.state.waitingAreaRoomsGray : this.state.waitingAreaRoomsFiltered;
      // If provider is in regular consultation
      let providerIsInCallWithSomeUser = this.props.isCurrentUserInCall || false;
      let answerCallPermission = false;
      if (this.props.waitingArea.permissions !== 'undefined' && this.props.waitingArea.permissions !== null) {
        answerCallPermission = this.props.waitingArea.permissions.indexOf('ANSWER_CALL') > -1;
      }
      return iterator.map((room, i) => {
        let minutes = getMinuteDiff(this.props.asOfNow, room.calculatedRoomWaitingFrom);
        return (
          <div
            className="row flexible row-hoverable "
            data-opaque={!!gray}
            key={room.id}
            onClick={(event) => {
              var trgt = event.target;
              var currentTrgt = event.currentTarget;
              let cb = () => {
                setTimeout(() => {
                  showHideMenu(null, '.new-waiting-area-view-one', room.id, trgt, currentTrgt);
                  setTimeout(() => {
                    let widthPlusLeft = $('.row').first().width(); //+ $('.row').first().position().left;
                    let contextualMenuStart = $('.contextual-menu-content').first().position().left;
                    this.setState({
                      maxWidthAllowedForParticipantRow:
                        widthPlusLeft - contextualMenuStart + this.state.maxWidthAllowedForParticipantRow,
                    }); //1 compensates for left :1-px
                  }, 0);
                }, 0);
              };
              this.props.dispatch(updateSelectedVideoCallRoomId(room.id, cb));
              // TODO - Need to remove the autickets when user leaves this page
              if (
                !room.isCurrentUserAnsweringThisCall &&
                !providerIsInCallWithSomeUser &&
                answerCallPermission &&
                !this.props.isCurrentUserInGCCall &&
                (!this.props.waitingArea.authTickets ||
                  (this.props.waitingArea.authTickets &&
                    !this.props.waitingArea.authTickets.some((x) => x.roomId === room.id)))
              ) {
                this.setState({ fetchingAuthTicket: true });
                var cbGetAuthTicket = (result, callScreenAuthTicket) => {
                  if (!result) {
                    console.error('No Auth Ticket was created');
                    return;
                  }
                  this.setState({ authTicketId: callScreenAuthTicket });
                  this.setState({ fetchingAuthTicket: false });
                };
                this.props.dispatch(createVidyoRoomAuthTicket(this.props.waitingArea.id, room.id, cbGetAuthTicket));
              }
            }}
          >
            {this.props.selectedVideoCallRoomId == room.id
              ? this.getContextualMenu(room, providerIsInCallWithSomeUser, answerCallPermission)
              : ''}
            <Container
              fluid
              as={Media}
              greaterThanOrEqual="tablet"
              className={
                this.props.calculateColor(room.mainParticipant.status, minutes) +
                ' left-column-fixed column status-column bold left-text inline-flex center-flex'
              }
              id="status-column"
              style={{ width: '25%' }}
            >
              <div className="span-like left-text waiting-text" style={{ whiteSpace: 'nowrap' }}>
                {room.mainParticipant.status}
              </div>
              {room.mainParticipant.status == APP.LANGUAGE.ViewOneWaitingArea.Attended ? (
                ''
              ) : (
                <span className={this.props.calculateColor(room.mainParticipant.status, minutes)}>
                  &nbsp;&#40;{minutes}&nbsp;
                  {APP.LANGUAGE.ViewOneWaitingArea.MinutesAbbreviation.toLowerCase()}
                  &#41;
                </span>
              )}
            </Container>
            <Container
              fluid
              as={Media}
              at="mobile"
              className={
                this.props.calculateColor(room.mainParticipant.status, minutes) +
                ' left-column-fixed column status-column bold left-text pdrnull flex-like center-flex'
              }
              id="status-column"
              style={{ width: '50%', fontSize: '0.94rem' }}
            >
              <div className="span-like left-text waiting-text" style={{ whiteSpace: 'nowrap' }}>
                {room.mainParticipant.status}
              </div>
              {room.mainParticipant.status == APP.LANGUAGE.ViewOneWaitingArea.Attended ? (
                ''
              ) : (
                <span className={this.props.calculateColor(room.mainParticipant.status, minutes)}>
                  &nbsp;&#40;{minutes}&nbsp;
                  {APP.LANGUAGE.ViewOneWaitingArea.MinutesAbbreviation.toLowerCase()}
                  &#41;
                </span>
              )}
            </Container>
            <Container
              fluid
              as={Media}
              greaterThanOrEqual="tablet"
              className="column pdlnull overflow-hidden inline-flex center-flex"
              style={{ width: '40%' }}
            >
              <Icon
                name="angle down"
                style={{ minWidth: '20px', marginTop: '-5px' }}
                className="mrrxs relative arrow-down-on-mobile"
              />
              {this.props.waitingArea.showDobField && room.dob ? (
                <span className="left-text caller-name">
                  {room.mainParticipant.name}
                  <div className="color-dob" style={{ fontSize: '0.92rem', fontWeight: '700' }}>
                    {getDOBFormat(room.dob)}
                  </div>
                </span>
              ) : (
                <span className="caller-name">{room.mainParticipant.name}</span>
              )}
            </Container>
            <Container
              fluid
              as={Media}
              greaterThanOrEqual="tablet"
              className="column pdlnull inline-flex center-flex"
              style={{ width: '25%' }}
            >
              <div className="caller-phone ellipsis">{room.mainParticipant.phone}</div>
            </Container>
            <Container fluid as={Media} at="mobile" className="column pdlnull inline-flex" style={{ width: '50%' }}>
              <Icon name="angle down" className="mrrxs arrow-down-on-mobile" style={{ marginTop: '-5px' }} />
              <div className="caller-info-wrapper">
                <div className="caller-name">{room.mainParticipant.name}</div>
                {this.props.waitingArea.showDobField && room.dob ? (
                  <div className="color-dob caller-phone" style={{ fontSize: '0.92rem', fontWeight: '700' }}>
                    {getDOBFormat(room.dob)}
                  </div>
                ) : (
                  ''
                )}
                <div className="color-gray caller-phone ellipsis" style={{ fontSize: '0.92rem', textAlign: 'left' }}>
                  {room.mainParticipant.phone}
                </div>
              </div>
            </Container>
            <div
              className="right-column-fixed column hide-on-small-ress center-text inline-flex center-with-flex"
              style={{ width: '10%' }}
            >
              {room.participants.length}
            </div>
          </div>
        );
      });
    };
    if (
      !this.props.fetchingWaitingArea ||
      this.state.waitingAreaRoomsFiltered.length > 0 ||
      this.state.waitingAreaRoomsGray.length > 0
    ) {
      peopleRows = renderWaitingArea(false);
      peopleGray = renderWaitingArea(true);
    } else {
      //loading template
      peopleRows = this.props.loadCallerRowTemplate();
    }

    let mainWAContent = (
      <span>
        <div onMouseMove={this.mouseMovedOnTable} className="ui center aligned padded grid">
          <Container
            fluid
            as={Media}
            greaterThanOrEqual="tablet"
            className="row flexible color-waiting-area-bg pdtnull pdbnull header-row pdlnull"
          >
            <span
              className="ui transparent large fluid icon input color-white  hand waiting-areas-filter column display-flex"
              style={{ width: '25%' }}
            >
              <input
                className="color-white color-waiting-area-highlight max-width  pdxs "
                id="input-in-row"
                type="text"
                onChange={(e) => this.updateWaitingAreaSearch(e)}
                value={this.props.currentWaitingAreaFilter}
                placeholder={APP.LANGUAGE.ViewOneWaitingArea.StatusPlaceholder}
              />
              <i className="filter icon mrrml" />
            </span>
            <span
              className="ui transparent large fluid icon input color-white waiting-areas-filter column display-flex"
              style={{ width: '40%' }}
            >
              <div className="color-white max-width pdxs left-text ">
                {APP.LANGUAGE.ViewOneWaitingArea.CallerPlaceholder}
              </div>
            </span>
            <span
              className="ui transparent large fluid icon input color-white waiting-areas-filter column display-flex hide-on-small-ress pdlnull"
              style={{ width: '25%' }}
            >
              <div className="color-white max-width pdxs pdlnull left-text ">
                {APP.LANGUAGE.ViewOneWaitingArea.TelephonePlaceholder}
              </div>
            </span>
            <span
              className="ui transparent large fluid icon input color-white  waiting-areas-filter center-flex column display-flex color-white hide-on-small-ress center-text"
              style={{ width: '10%' }}
            >
              <span style={{ margin: 'auto' }}>
                <Icon name="user" style={{ marginTop: '4px', fontSize: '1rem' }} />
              </span>
              <span className="max-width  show-on-small-ress">
                <i className="ui icon group pdts" />
              </span>
            </span>
          </Container>
          <Container
            fluid
            as={Media}
            at="mobile"
            className="row flexible color-waiting-area-bg pdtnull pdbnull header-row pdlnull"
          >
            <span
              className="ui transparent large fluid icon input color-white  hand waiting-areas-filter column display-flex"
              style={{ width: '50%' }}
            >
              <input
                className="color-white color-waiting-area-highlight max-width  pdxs "
                id="input-in-row"
                type="text"
                onChange={(e) => this.updateWaitingAreaSearch(e)}
                value={this.props.currentWaitingAreaFilter}
                placeholder={APP.LANGUAGE.ViewOneWaitingArea.StatusPlaceholder}
              />
              <i className="filter icon mrrml" />
            </span>
            <span
              className="ui transparent large fluid icon input color-white waiting-areas-filter column display-flex"
              style={{ width: '50%' }}
            >
              <div className="color-white max-width pdxs left-text ">
                {APP.LANGUAGE.ViewOneWaitingArea.CallerPlaceholder}
              </div>
            </span>
          </Container>
          {/* Will render No calls, Suspend/Resume rows */}
          <CenterPanelShared
            waitingArea={this.props.waitingArea}
            fetchingWaitingArea={this.props.fetchingWaitingArea}
            timezone={this.props.timezone}
            waitingAreaRoomsGray={this.props.waitingAreaRoomsGray}
            waitingAreaRoomsFiltered={this.props.waitingAreaRoomsFiltered}
            dispatch={this.props.dispatch}
            waitingAreaClosingMessageThresholdMinutes={this.props.waitingAreaClosingMessageThresholdMinutes}
          />
          {peopleRows}
          {peopleGray}
          {newRoomInWaitingAreaSound}
        </div>
      </span>
    );
    if (this.props.isConsultNowEnabled) {
      let mainContent = mainWAContent;
      if (this.props.activeTabItem === APP.LANGUAGE.ViewOneWaitingArea.ConsultNow.toUpperCase()) {
        let noInitiatedCallMessage = '';
        let noInProgressCallMessage = '';
        let consultNowPeopleRows = {
          initiatedCalls: '',
          inProgressCalls: '',
        };

        let renderCNInitiatedCallsRows = (gray) => {
          let iterator = this.props.consultNowInitiatedRoomsFiltered;
          let providerIsInCallWithSomeUser = this.props.isCurrentUserInCall || false;
          let answerCallPermission = this.props.waitingArea.permissions.indexOf('ANSWER_CALL') > -1;
          return iterator.map((callerData, i) => {
            // Convert expiry time to remaining time
            let remainingSeonds = 0;
            if (!!callerData.expiryDate) {
              remainingSeonds = getRemainingSecond(callerData.expiryDate);
            }
            let remainingTime = <RemainingTimeCountDown seconds={parseInt(remainingSeonds)} onCompleteCb={() => {}} />;

            return (
              <div
                className="row flexible row-hoverable "
                data-opaque={!!gray}
                key={i}
                onClick={(event) => {
                  var trgt = event.target;
                  var currentTrgt = event.currentTarget;
                  showHideMenu(null, '.new-waiting-area-view-one', i, trgt, currentTrgt);
                  let cb = () => {
                    setTimeout(() => {
                      let widthPlusLeft = $('.row').first().width(); //+ $('.row').first().position().left;
                      let contextualMenuStart = $('.contextual-menu-content').first().position().left;
                      this.setState({
                        maxWidthAllowedForParticipantRow:
                          widthPlusLeft - contextualMenuStart + this.state.maxWidthAllowedForParticipantRow,
                      }); //1 compensates for left :1-px
                    }, 0);
                  };
                  this.props.dispatch(updateSelectedConsultNowCaller(callerData, cb));
                }}
              >
                <ConsultNowContextMenu
                  waitingArea={this.props.waitingArea}
                  callerData={callerData}
                  index={i}
                  providerIsInCallWithSomeUser={providerIsInCallWithSomeUser}
                  answerCallPermission={answerCallPermission}
                  permissions={this.props.waitingArea.permissions}
                  dispatch={this.props.dispatch}
                />
                <Container
                  fluid
                  as={Media}
                  greaterThanOrEqual="tablet"
                  className="left-column-fixed column status-column left-text center-flex"
                  id="status-column"
                  style={{ width: '25%' }}
                >
                  <div className="left-text bold waiting-text waiting-area-orange">
                    {APP.LANGUAGE.ViewOneWaitingArea.InitiatedCallsStatus}
                  </div>
                  <div className="left-text waiting-text">
                    {remainingTime}
                    {APP.LANGUAGE.ViewOneWaitingArea.Remaining}
                  </div>
                </Container>
                <Container
                  fluid
                  as={Media}
                  at="mobile"
                  className=" left-column-fixed column status-column left-text pdrnull flex-like center-flex"
                  id="status-column"
                  style={{ width: '50%', fontSize: '0.94rem' }}
                >
                  <div className="left-text bold waiting-text waiting-area-orange" style={{ whiteSpace: 'nowrap' }}>
                    {APP.LANGUAGE.ViewOneWaitingArea.InitiatedCallsStatus}
                  </div>
                  <div className="left-text waiting-text" style={{ whiteSpace: 'nowrap' }}>
                    {remainingTime}
                    {APP.LANGUAGE.ViewOneWaitingArea.Remaining}
                  </div>
                </Container>
                <Container
                  fluid
                  as={Media}
                  greaterThanOrEqual="tablet"
                  className="column pdlnull overflow-hidden inline-flex center-flex"
                  style={{ width: '25%' }}
                >
                  <Icon
                    name="angle down"
                    style={{ minWidth: '20px', marginTop: '-5px' }}
                    className="mrrxs relative arrow-down-on-mobile"
                  />
                  <span className="caller-name">{`${callerData.firstName} ${callerData.lastName}`}</span>
                </Container>
                <Container
                  fluid
                  as={Media}
                  greaterThanOrEqual="tablet"
                  className={
                    callerData.telephone &&
                    callerData.telephone.trim() != '' &&
                    callerData.email &&
                    callerData.email.trim() != ''
                      ? 'column pdlnull display-flex center-with-flex flex-direction-column'
                      : 'column pdlnull display-flex center-flex'
                  }
                  style={{ width: '25%' }}
                >
                  {callerData.telephone && callerData.telephone.trim() != '' ? (
                    <div className="ellipsis max-width left-text" id="consult-now-caller-phone">
                      {callerData.telephone}
                    </div>
                  ) : (
                    ''
                  )}
                  {callerData.email && callerData.email.trim() != '' ? (
                    <div className="ellipsis max-width left-text" id="consult-now-caller-email">
                      {callerData.email}
                    </div>
                  ) : (
                    ''
                  )}
                </Container>
                <Container fluid as={Media} at="mobile" className="column pdlnull inline-flex" style={{ width: '50%' }}>
                  <Icon name="angle down" className="mrrxs arrow-down-on-mobile" />
                  <div className="caller-info-wrapper">
                    <div className="caller-name">{`${callerData.firstName} ${callerData.lastName}`}</div>
                    {callerData.telephone && callerData.telephone.trim() != '' ? (
                      <div
                        className="color-gray caller-phone ellipsis"
                        style={{ fontSize: '0.92rem', textAlign: 'left' }}
                      >
                        {callerData.telephone}
                      </div>
                    ) : (
                      ''
                    )}
                    {callerData.email && callerData.email.trim() != '' ? (
                      <div
                        className="color-gray caller-phone ellipsis"
                        style={{ fontSize: '0.92rem', textAlign: 'left' }}
                      >
                        {callerData.email}
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </Container>
                <div
                  className="right-column-fixed column hide-on-small-ress center-flex inline-flex"
                  style={{ width: '25%' }}
                >
                  {`${callerData.providerFirstName} ${callerData.providerLastName}`}
                </div>
              </div>
            );
          });
        };

        let renderCNInProgressCallsRows = (gray) => {
          let iterator = this.props.consultNowRoomsFiltered;

          let providerIsInCallWithSomeUser = this.props.isCurrentUserInCall || false;
          let answerCallPermission = this.props.waitingArea.permissions.indexOf('ANSWER_CALL') > -1;
          return iterator.map((room, i) => {
            let minutes = getMinuteDiff(this.props.asOfNow, room.calculatedRoomWaitingFrom);
            return (
              <div
                className="row flexible row-hoverable "
                data-opaque={!!gray}
                key={room.id}
                onClick={(event) => {
                  var trgt = event.target;
                  var currentTrgt = event.currentTarget;
                  let cb = () => {
                    setTimeout(() => {
                      showHideMenu(null, '.new-waiting-area-view-one', room.id, trgt, currentTrgt);
                      setTimeout(() => {
                        let widthPlusLeft = $('.row').first().width(); //+ $('.row').first().position().left;
                        let contextualMenuStart = $('.contextual-menu-content').first().position().left;
                        this.setState({
                          maxWidthAllowedForParticipantRow:
                            widthPlusLeft - contextualMenuStart + this.state.maxWidthAllowedForParticipantRow,
                        }); //1 compensates for left :1-px
                      }, 0);
                    }, 0);
                  };
                  this.props.dispatch(updateSelectedVideoCallRoomId(room.id, cb));
                  if (
                    !room.isCurrentUserAnsweringThisCall &&
                    !providerIsInCallWithSomeUser &&
                    answerCallPermission &&
                    (!this.props.waitingArea.authTickets ||
                      (this.props.waitingArea.authTickets &&
                        !this.props.waitingArea.authTickets.some((x) => x.roomId === room.id)))
                  ) {
                    this.setState({ fetchingAuthTicket: true });
                    var cbGetAuthTicket = (result, callScreenAuthTicket) => {
                      if (!result) {
                        console.error('No Auth Ticket was created');
                        return;
                      }
                      this.setState({ authTicketId: callScreenAuthTicket });
                      this.setState({ fetchingAuthTicket: false });
                    };
                    this.props.dispatch(createVidyoRoomAuthTicket(this.props.waitingArea.id, room.id, cbGetAuthTicket));
                  }
                }}
              >
                {this.props.selectedVideoCallRoomId == room.id
                  ? this.getContextualMenu(room, providerIsInCallWithSomeUser, answerCallPermission)
                  : ''}
                <Container
                  fluid
                  as={Media}
                  greaterThanOrEqual="tablet"
                  className={
                    this.props.calculateColor(room.mainParticipant.status, minutes) +
                    ' left-column-fixed column status-column bold left-text inline-flex center-flex'
                  }
                  id="status-column"
                  style={{ width: '25%' }}
                >
                  <div className="span-like left-text waiting-text" style={{ whiteSpace: 'nowrap' }}>
                    {room.mainParticipant.status}
                  </div>
                  {room.mainParticipant.status == APP.LANGUAGE.ViewOneWaitingArea.Attended ? (
                    ''
                  ) : (
                    <span className={this.props.calculateColor(room.mainParticipant.status, minutes)}>
                      &nbsp;&#40;{minutes}&nbsp;
                      {APP.LANGUAGE.ViewOneWaitingArea.MinutesAbbreviation.toLowerCase()}
                      &#41;
                    </span>
                  )}
                </Container>
                <Container
                  fluid
                  as={Media}
                  at="mobile"
                  className={
                    this.props.calculateColor(room.mainParticipant.status, minutes) +
                    ' left-column-fixed column status-column bold left-text pdrnull flex-like center-flex'
                  }
                  id="status-column"
                  style={{ width: '50%', fontSize: '0.94rem' }}
                >
                  <div className="span-like left-text waiting-text" style={{ whiteSpace: 'nowrap' }}>
                    {room.mainParticipant.status}
                  </div>
                  {room.mainParticipant.status == APP.LANGUAGE.ViewOneWaitingArea.Attended ? (
                    ''
                  ) : (
                    <span className={this.props.calculateColor(room.mainParticipant.status, minutes)}>
                      &nbsp;&#40;{minutes}&nbsp;
                      {APP.LANGUAGE.ViewOneWaitingArea.MinutesAbbreviation.toLowerCase()}
                      &#41;
                    </span>
                  )}
                </Container>
                <Container
                  fluid
                  as={Media}
                  greaterThanOrEqual="tablet"
                  className="column pdlnull overflow-hidden inline-flex center-flex"
                  style={{ width: '40%' }}
                >
                  <Icon
                    name="angle down"
                    style={{ minWidth: '20px', marginTop: '-5px' }}
                    className="mrrxs relative arrow-down-on-mobile"
                  />
                  {this.props.waitingArea.showDobField && room.dob ? (
                    <span className="left-text caller-name">
                      {room.mainParticipant.name}
                      <div className="color-dob" style={{ fontSize: '0.92rem', fontWeight: '700' }}>
                        {getDOBFormat(room.dob)}
                      </div>
                    </span>
                  ) : (
                    <span className="caller-name">{room.mainParticipant.name}</span>
                  )}
                </Container>
                <Container
                  fluid
                  as={Media}
                  greaterThanOrEqual="tablet"
                  className="column pdlnull inline-flex center-flex"
                  style={{ width: '25%' }}
                >
                  <div className="caller-phone ellipsis">{room.mainParticipant.phone}</div>
                </Container>
                <Container fluid as={Media} at="mobile" className="column pdlnull inline-flex" style={{ width: '50%' }}>
                  <Icon name="angle down" className="mrrxs arrow-down-on-mobile" style={{ marginTop: '-5px' }} />
                  <div className="caller-info-wrapper">
                    <div className="caller-name">{room.mainParticipant.name}</div>
                    {this.props.waitingArea.showDobField && room.dob ? (
                      <div className="color-dob caller-phone" style={{ fontSize: '0.92rem', fontWeight: '700' }}>
                        {getDOBFormat(room.dob)}
                      </div>
                    ) : (
                      ''
                    )}
                    <div
                      className="color-gray caller-phone ellipsis"
                      style={{ fontSize: '0.92rem', textAlign: 'left' }}
                    >
                      {room.mainParticipant.phone}
                    </div>
                  </div>
                </Container>
                <div
                  className="right-column-fixed column hide-on-small-ress center-text inline-flex center-with-flex"
                  style={{ width: '10%' }}
                >
                  {room.participants.length}
                </div>
              </div>
            );
          });
        };

        if (!this.props.fetchingWaitingArea) {
          if (this.props.consultNowInitiatedRoomsFiltered && this.props.consultNowInitiatedRoomsFiltered.length > 0) {
            consultNowPeopleRows.initiatedCalls = renderCNInitiatedCallsRows(false);
          } else if (
            !waitingArea.isSuspended &&
            waitingArea.operatingHours &&
            waitingArea.operatingHours.isOpen &&
            this.props.consultNowInitiatedRoomsFiltered &&
            this.props.consultNowInitiatedRoomsFiltered.length === 0
          ) {
            noInitiatedCallMessage = (
              <div className="row flexible row-hoverable center-text pointer">
                <div className="column text-size-ml">{APP.LANGUAGE.ViewOneWaitingArea.NoInitiatedCallsConsultNow}</div>
              </div>
            );
          } else {
            //loading template
            consultNowPeopleRows = [{}, {}].map((o, i) => {
              return {
                initiatedCalls: (
                  <div className="row flexible row-hoverable " key={i}>
                    {i == 0 ? (
                      <div className="ui active inverted dimmer">
                        <div className="ui text loader pdtxl mrtl " />
                      </div>
                    ) : (
                      <div className="ui active inverted dimmer" />
                    )}
                    <div className="column status-column bold hide-on-small-ress" style={{ width: '25%' }}>
                      <div className="max-width span-like left-text color-gray-bg color-gray">asd</div>
                      <div className="right-text pdrs max-width span-like color-gray-bg color-gray">
                        <span>asd</span>
                      </div>
                    </div>
                    <div
                      className=" left-column-fixed column bold show-on-small-ress flex-like center-flex"
                      style={{ width: '50%', fontSize: '0.94rem' }}
                    >
                      <div className="mrlm mrtm color-gray-bg color-gray" style={{ width: '80%' }}>
                        asdasdasd
                      </div>
                    </div>
                    <Container
                      fluid
                      as={Media}
                      greaterThanOrEqual="tablet"
                      className="right-column-fixed"
                      style={{ width: '65%' }}
                    >
                      <div className="column pdlnull inline-flex" style={{ width: '61.5%' }}>
                        <div className="color-gray-bg color-gray left-text">asdasdasdasd</div>
                      </div>
                      <div className="column pdlnull inline-flex" style={{ width: '38.5%' }}>
                        <div className="color-gray-bg color-gray right-text">asdasdasdasd</div>
                      </div>
                    </Container>
                    <Container fluid as={Media} at="mobile" className="right-column-fixed" style={{ width: '50%' }}>
                      <div className="column pdlm inline-flex center-flex">
                        <div>
                          <div className="color-gray-bg color-gray mrbxxs" style={{ fontSize: '0.92rem' }}>
                            asdasdasdasd
                          </div>
                          <div className="color-gray-bg color-gray" style={{ fontSize: '0.92rem' }}>
                            asdasdasdasd
                          </div>
                        </div>
                      </div>
                    </Container>
                    <div
                      className="right-column-fixed column pdlxs hide-on-small-ress center-text"
                      style={{ width: '10%' }}
                    >
                      <span className="color-gray-bg color-gray">asdas</span>
                    </div>
                  </div>
                ),
                inProgressCalls: '',
              };
            });
          }
          if (this.props.consultNowRoomsFiltered && this.props.consultNowRoomsFiltered.length > 0) {
            consultNowPeopleRows.inProgressCalls = renderCNInProgressCallsRows(false);
          } else if (this.props.consultNowRoomsFiltered && this.props.consultNowRoomsFiltered.length == 0) {
            noInProgressCallMessage = (
              <div className="row flexible row-hoverable center-text pointer" id="no-in-progress-call">
                <div className="column text-size-ml">{APP.LANGUAGE.ViewOneWaitingArea.NoInProgressCallsConsultNow}</div>
              </div>
            );
          }
        }

        mainContent = (
          <div>
            <Container fluid as={Media} greaterThanOrEqual="computer" className="mrtl mrbm text-size-ml bold">
              {APP.LANGUAGE.ViewOneWaitingArea.InitiatedCalls}
            </Container>
            <Container fluid as={Media} lessThan="computer" className="mrtl mrbm text-size-ml bold pdlm">
              {APP.LANGUAGE.ViewOneWaitingArea.InitiatedCalls}
            </Container>
            <div onMouseMove={this.mouseMovedOnTable} className="ui center aligned padded grid">
              <Container
                fluid
                as={Media}
                greaterThanOrEqual="tablet"
                className="row flexible color-waiting-area-bg pdtnull pdbnull header-row pdlnull"
              >
                <span
                  className="ui transparent large fluid icon input color-white waiting-areas-filter column display-flex center-with-flex"
                  style={{ width: '25%' }}
                >
                  <div className="color-white max-width pdxs left-text ">
                    {APP.LANGUAGE.ViewOneWaitingArea.StatusPlaceholder}
                  </div>
                  {/* TODO: Search Filter will be done in MVP+ */}
                  {/* <input
                    className="color-white color-waiting-area-highlight max-width  pdxs "
                    id="input-in-row"
                    type="text"
                    onChange={e => this.updateInitiatedCNWaitingAreaSearch(e)}
                    value={this.props.consultNowInitiatedWaitingAreasFilter}
                    placeholder={APP.LANGUAGE.ViewOneWaitingArea.StatusPlaceholder}
                  />
                  <i className="filter icon mrrml" /> */}
                </span>
                <span
                  className="ui transparent large fluid icon input color-white waiting-areas-filter column display-flex center-with-flex"
                  style={{ width: '25%' }}
                >
                  <div className="color-white max-width pdxs left-text ">
                    {APP.LANGUAGE.ViewOneWaitingArea.CallerPlaceholder}
                  </div>
                </span>
                <span
                  className="ui transparent large fluid icon input color-white waiting-areas-filter column display-flex center-with-flex hide-on-small-ress pdlnull"
                  style={{ width: '25%' }}
                >
                  <div className="color-white max-width pdxs pdlnull left-text ">
                    {APP.LANGUAGE.ViewOneWaitingArea.MobileEmailPlaceholder}
                  </div>
                </span>
                <span
                  className="ui transparent large fluid icon input color-white  waiting-areas-filter center-flex column display-flex color-white hide-on-small-ress center-text"
                  style={{ width: '25%' }}
                >
                  <div className="color-white max-width pdxs pdlnull left-text ">
                    {APP.LANGUAGE.ViewOneWaitingArea.ProviderName}
                  </div>
                </span>
              </Container>
              <Container
                fluid
                as={Media}
                at="mobile"
                className="row flexible color-waiting-area-bg pdtnull pdbnull header-row pdlnull"
              >
                <span
                  className="ui transparent large fluid icon input color-white waiting-areas-filter column display-flex"
                  style={{ width: '50%' }}
                >
                  <div className="color-white max-width pdxs left-text ">
                    {APP.LANGUAGE.ViewOneWaitingArea.StatusPlaceholder}
                  </div>
                  {/* TODO: Search Filter will be done in MVP+ */}
                  {/* <input
                    className="color-white color-waiting-area-highlight max-width  pdxs "
                    id="input-in-row"
                    type="text"
                    onChange={e => this.updateInitiatedCNWaitingAreaSearch(e)}
                    value={this.props.consultNowInitiatedWaitingAreasFilter}
                    placeholder={APP.LANGUAGE.ViewOneWaitingArea.StatusPlaceholder}
                  />
                  <i className="filter icon mrrml" /> */}
                </span>
                <span
                  className="ui transparent large fluid icon input color-white waiting-areas-filter column display-flex"
                  style={{ width: '50%' }}
                >
                  <div className="color-white max-width pdxs left-text ">
                    {APP.LANGUAGE.ViewOneWaitingArea.CallerPlaceholder}
                  </div>
                </span>
              </Container>
              {/* Will render Suspend/Resume rows */}
              <CenterPanelShared
                waitingArea={this.props.waitingArea}
                fetchingWaitingArea={this.props.fetchingWaitingArea}
                timezone={this.props.timezone}
                waitingAreaRoomsGray={this.props.waitingAreaRoomsGray}
                waitingAreaRoomsFiltered={this.props.waitingAreaRoomsFiltered}
                dispatch={this.props.dispatch}
                waitingAreaClosingMessageThresholdMinutes={this.props.waitingAreaClosingMessageThresholdMinutes}
                isForConsultNow={true}
              />
              {noInitiatedCallMessage}
              {consultNowPeopleRows.initiatedCalls}
              {newRoomInWaitingAreaSound}
            </div>
            <Container fluid as={Media} greaterThanOrEqual="computer" className="mrtl mrbm text-size-ml bold">
              {APP.LANGUAGE.ViewOneWaitingArea.InProgressCalls}
            </Container>
            <Container fluid as={Media} lessThan="computer" className="mrtl mrbm text-size-ml bold pdlm">
              {APP.LANGUAGE.ViewOneWaitingArea.InProgressCalls}
            </Container>
            <div onMouseMove={this.mouseMovedOnTable} className="ui center aligned padded grid">
              <Container
                fluid
                as={Media}
                greaterThanOrEqual="tablet"
                className="row flexible color-waiting-area-bg pdtnull pdbnull header-row pdlnull"
              >
                <span
                  className="ui transparent large fluid icon input color-white waiting-areas-filter column display-flex"
                  style={{ width: '25%' }}
                >
                  <div className="color-white max-width pdxs left-text ">
                    {APP.LANGUAGE.ViewOneWaitingArea.StatusPlaceholder}
                  </div>
                  {/* TODO: Search Filter will be done in MVP+ */}
                  {/* <input
                    className="color-white color-waiting-area-highlight max-width  pdxs "
                    id="input-in-row"
                    type="text"
                    onChange={e => this.updateInprogressCNWaitingAreaSearch(e)}
                    value={this.props.consultNowInporgressWaitingAreasFilter}
                    placeholder={APP.LANGUAGE.ViewOneWaitingArea.StatusPlaceholder}
                  />
                  <i className="filter icon mrrml" /> */}
                </span>
                <span
                  className="ui transparent large fluid icon input color-white waiting-areas-filter column display-flex"
                  style={{ width: '40%' }}
                >
                  <div className="color-white max-width pdxs left-text ">
                    {APP.LANGUAGE.ViewOneWaitingArea.CallerPlaceholder}
                  </div>
                </span>
                <span
                  className="ui transparent large fluid icon input color-white waiting-areas-filter column display-flex hide-on-small-ress pdlnull"
                  style={{ width: '25%' }}
                >
                  <div className="color-white max-width pdxs pdlnull left-text ">
                    {APP.LANGUAGE.ViewOneWaitingArea.TelephonePlaceholder}
                  </div>
                </span>
                <span
                  className="ui transparent large fluid icon input color-white  waiting-areas-filter center-flex column display-flex color-white hide-on-small-ress center-text"
                  style={{ width: '10%' }}
                >
                  <span style={{ margin: 'auto' }}>
                    <Icon name="user" style={{ marginTop: '4px', fontSize: '1rem' }} />
                  </span>
                  <span className="max-width  show-on-small-ress">
                    <i className="ui icon group pdts" />
                  </span>
                </span>
              </Container>
              <Container
                fluid
                as={Media}
                at="mobile"
                className="row flexible color-waiting-area-bg pdtnull pdbnull header-row pdlnull"
              >
                <span
                  className="ui transparent large fluid icon input color-white waiting-areas-filter column display-flex"
                  style={{ width: '50%' }}
                >
                  <div className="color-white max-width pdxs left-text ">
                    {APP.LANGUAGE.ViewOneWaitingArea.StatusPlaceholder}
                  </div>
                  {/* TODO: Search Filter will be done in MVP+ */}
                  {/* <input
                    className="color-white color-waiting-area-highlight max-width  pdxs "
                    id="input-in-row"
                    type="text"
                    onChange={e => this.updateInprogressCNWaitingAreaSearch(e)}
                    value={this.props.consultNowInporgressWaitingAreasFilter}
                    placeholder={APP.LANGUAGE.ViewOneWaitingArea.StatusPlaceholder}
                  />
                  <i className="filter icon mrrml" /> */}
                </span>
                <span
                  className="ui transparent large fluid icon input color-white waiting-areas-filter column display-flex"
                  style={{ width: '50%' }}
                >
                  <div className="color-white max-width pdxs left-text ">
                    {APP.LANGUAGE.ViewOneWaitingArea.CallerPlaceholder}
                  </div>
                </span>
              </Container>
              {noInProgressCallMessage}
              {consultNowPeopleRows.inProgressCalls}
              {newRoomInWaitingAreaSound}
            </div>
          </div>
        );
      }
      return (
        <div>
          <Menu pointing secondary id="wa-consult-now-menu">
            <Menu.Item
              name={APP.LANGUAGE.ViewOneWaitingArea.MainWaitingArea}
              active={this.props.activeTabItem === APP.LANGUAGE.ViewOneWaitingArea.MainWaitingArea}
              onClick={this.props.handleTabClick}
            >
              <span>{APP.LANGUAGE.ViewOneWaitingArea.MainWaitingArea.toUpperCase()}</span>
              {(this.state.waitingAreaRoomsFiltered.length == 0 || this.state.waitingAreaRoomsGray.length == 0) &&
              this.anyCallNotInProgress([
                ...this.state.waitingAreaRoomsFiltered,
                ...this.state.waitingAreaRoomsGray,
              ]) ? (
                <span className="activeIndicator color-white">{APP.LANGUAGE.ViewOneWaitingArea.NewCallers}</span>
              ) : null}
            </Menu.Item>
            <Menu.Item
              name={APP.LANGUAGE.ViewOneWaitingArea.ConsultNow.toUpperCase()}
              active={this.props.activeTabItem === APP.LANGUAGE.ViewOneWaitingArea.ConsultNow.toUpperCase()}
              onClick={this.props.handleTabClick}
            >
              <span>{APP.LANGUAGE.ViewOneWaitingArea.ConsultNow.toUpperCase()}</span>
              {this.props.consultNowInitiatedRoomsFiltered.length > 0 ||
              (this.props.consultNowRoomsFiltered.length > 0 &&
                this.anyCallNotInProgress(this.props.consultNowRoomsFiltered)) ? (
                <span className="activeIndicator color-white">{APP.LANGUAGE.ViewOneWaitingArea.NewCallers}</span>
              ) : null}
            </Menu.Item>
          </Menu>
          <div className="mrtm consult-now-container">{mainContent}</div>
        </div>
      );
    }
    return mainWAContent;
  }
}
function mapStateToProps(state) {
  return {
    waitingAreaParticipants: state.usersReducer.waitingAreaParticipants,
    asOfNow: state.sharedReducer.asOfNow,
    showNotifyRoomParticipantModal: state.modalReducer.showNotifyRoomParticipantModal,
    isCurrentUserInCall: state.usersReducer.isInCall,
    isCurrentUserInGCCall: state.usersReducer.isInGCCall,
    isConsultNowIssued: state.usersReducer.userProfile.isConsultNowIssued,
    waitingAreaClosingMessageThresholdMinutes: state.usersReducer.userProfile.waitingAreaClosingMessageThresholdMinutes,
    showConfirmationCallMessModal: state.modalReducer.showConfirmationCallMessModal,
  };
}
